import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { useGetFeaturesSettings } from '@/domain/settings'
import { useUserStore } from '@/store/useUserStore'
import { extractPhoneNumberInfosWithoutRegionCode } from '@/utils/phoneNumber/extractPhoneNumberInfosWithoutRegionCode'
import { useTheme } from '@/hooks/useTheme'

export const InvitationReward = () => {
  const navigate = useNavigate()
  const theme = useTheme()

  const phoneNumber = useUserStore(
    (s) => s.userAuthenticated?.phone_number,
  )
  const documentCountry = useUserStore(
    (s) => (s.userAuthenticated as Record<string, any> | null)?.document_country as string | undefined,
  )

  const { data: featureSettings, isLoading: isLoadingFeatureSettings } =
    useGetFeaturesSettings()

  const checkIfShouldShowInviteFriendBanner = useCallback((): boolean => {
    const { iso3Code } = phoneNumber
      ? extractPhoneNumberInfosWithoutRegionCode(phoneNumber)
      : { iso3Code: '' }
    const enabledRegions = featureSettings?.rewards?.allowed_countries

    const isRegionEnabled =
      !documentCountry && !iso3Code
        ? true
        : enabledRegions?.includes(documentCountry ?? '') ||
          enabledRegions?.includes(iso3Code ?? '')

    if (!featureSettings?.shouldDisplayReferralBonuses) {
      return false
    }

    if (!isRegionEnabled) {
      return false
    }

    return true
  }, [
    featureSettings?.shouldDisplayReferralBonuses,
    documentCountry,
    featureSettings?.rewards?.allowed_countries,
    phoneNumber,
  ])

  if (isLoadingFeatureSettings) {
    return (
      <BaseView
        rounded={20}
        h={30}
        style={{
          width: 100,
          backgroundColor: theme.colors.background.screen,
          opacity: 0.5,
        }}
      />
    )
  }

  if (!checkIfShouldShowInviteFriendBanner()) {
    return null
  }

  return (
    <BaseView
      px={10}
      py={4}
      rounded={20}
      style={{
        backgroundColor: 'rgba(255, 214, 0, 0.2)',
        cursor: 'pointer',
      }}
      onClick={() => navigate('/invite-friends')}
    >
      <BaseText
        fontSize={12}
        style={{
          color: '#FFD600',
          fontWeight: 500,
          whiteSpace: 'nowrap',
        }}
      >
        {`EARN ${featureSettings?.reward_limit_formatted ?? ''}`}
      </BaseText>
    </BaseView>
  )
}
